import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { LayoutContext } from '../../../contexts/LayoutContext';
import AptiviewLoader from './AptiviewLoader';

/**
 * Branded loader overlay scoped to the main content panel when the app
 * shell is mounted (sidebar/navbar stay visible). Falls back to a full
 * viewport overlay on routes without the layout shell.
 */
export default function FullScreenLoader({
  show = true,
  message = 'Getting your interview space ready…',
}) {
  const { mainContentRef } = React.useContext(LayoutContext);
  const [portalTarget, setPortalTarget] = useState(null);

  useLayoutEffect(() => {
    if (!show) {
      setPortalTarget(null);
      return undefined;
    }

    const resolveTarget = () => {
      const mainEl = mainContentRef?.current;
      setPortalTarget(mainEl || document.body);
    };

    resolveTarget();
    const frame = requestAnimationFrame(resolveTarget);
    return () => cancelAnimationFrame(frame);
  }, [show, mainContentRef]);

  if (!show || !portalTarget || typeof document === 'undefined') return null;

  const scopedToMain = portalTarget !== document.body;

  return createPortal(
    <AptiviewLoader
      variant={scopedToMain ? 'content' : 'fullscreen'}
      message={message}
    />,
    portalTarget
  );
}
